import { apiClient } from './client';
import type { User, LoginRequest, UpdatePreferencesRequest, UserPreferences } from '../types';

export const authApi = {
  /**
   * Login with username and password
   */
  async login(credentials: LoginRequest): Promise<User> {
    return apiClient.post<User>('/api/auth/login', credentials);
  },

  /**
   * Get current authenticated user
   */
  async getCurrentUser(): Promise<User> {
    return apiClient.get<User>('/api/auth/me');
  },

  /**
   * Logout current user
   */
  async logout(): Promise<void> {
    return apiClient.post<void>('/api/auth/logout');
  },

  /**
   * Update user preferences
   */
  async updatePreferences(preferences: UpdatePreferencesRequest): Promise<{ preferences: UserPreferences }> {
    return apiClient.patch<{ preferences: UserPreferences }>('/api/auth/preferences', preferences);
  },
};
